import { createContext } from "react";

export const UserContext = createContext({});
export const RelayContext = createContext([]);